import React, {Component} from 'react';
import Popup from "../popups/Popup";
//import Slider from "react-slick";

import 'slick-carousel';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import $ from "jquery";


const settings = {

};

class RatingComponent extends Component {
    state = {
        avg_rating: 0.0,
        total_reviews: 0,
        list_reviews: []
    }
    constructor(props) {
        super(props);
        this.drawStars = this.drawStars.bind(this);
    }
    /*
    componentWillReceiveProps(newProps) {
        this.setState(newProps.reviews);
        $('.rating-reviews .slick-slider-wrap').slick({
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
        });
    }*/

    componentWillUnmount() {
        if ($('.rating-reviews .slick-slider-wrap').hasClass('slick-initialized'))
            $('.rating-reviews .slick-slider-wrap').slick('unslick');
    }
    componentDidUpdate(prevProps) {
        if (prevProps.reviews !== this.props.reviews) {
            this.setState( this.props.reviews, () => {
                if ($('.rating-reviews .slick-slider-wrap').hasClass('slick-initialized')) {
                    $('.rating-reviews .slick-slider-wrap').slick('unslick');
                }
                $('.rating-reviews .slick-slider-wrap').slick({
                    dots: false,
                    infinite: true,
                    speed: 500,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                });
            });
        }
    }

    drawStars(rating) {
        let perc = rating/5*100
        return (
            <div className="rating">
                <div className="rating-upper" style={{width: perc+'%'}}>
                    <span>★</span>
                    <span>★</span>
                    <span>★</span>
                    <span>★</span>
                    <span>★</span>
                </div>
                <div className="rating-lower">
                    <span>★</span>
                    <span>★</span>
                    <span>★</span>
                    <span>★</span>
                    <span>★</span>
                </div>
            </div>
        )
    }
    render() {
        return (
            <div className="rating-reviews">
                {this.drawStars(this.state.avg_rating)}
                <div className="statistic">
                    <div><span className="red">{this.state.avg_rating}</span> Average</div>
                    <div className="v-slash">|</div>
                    <div><span className="red">{this.state.total_reviews}</span> Reviews</div>
                    <div className="v-slash">|</div>
                    <div>
                        <Popup trigger={<span className="cursor-pointer red">Read All</span>}
                               modal
                               lockScroll
                               closeOnDocumentClick={false}
                               className={"bm-modal"}
                        >
                            {close => (<div className="p-1">
                                <button type="button" className="close" aria-label="Close" onClick={close}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <div className="clearfix" />
                                <div className="text-center">
                                    <h2>Hear What Our Customers Say About Us</h2>
                                    <div className="bg-green popup_rating_block">
                                        <div className="review-lizard-with-thumb-up" />
                                        <div className="popup_rating_wrap">
                                            <div className="flex-column align-content-center">
                                                <div className="smaller-stars">
                                                    {this.drawStars(this.state.avg_rating)}
                                                </div>
                                                <div className="text"><span className="count">{this.state.avg_rating}</span> Average</div>
                                                <div className="text"><span className="count">{this.state.total_reviews}</span> Reviews</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="slick-slider-wrap">
                                    {this.state.list_reviews && this.state.list_reviews.length > 0 && (
                                        <div>
                                        {this.state.list_reviews.map((item,i)=> {
                                            return (
                                                <div className="item-review" key={i}>
                                                    <div className="feedback"><span>{item.feedback}</span></div>
                                                    <div className="smaller-stars">{this.drawStars(item.rating)}</div>
                                                    <div className="name">{item.first_name}</div>
                                                    <div className="time">{item.dropoff}</div>
                                                </div>
                                            )
                                        })}
                                        </div>
                                    )}
                                </div>
                            </div>)}
                        </Popup>
                    </div>
                </div>
            </div>
        );
    }
}

export default RatingComponent;